import {
    SizeActionTypes,
    PreviewSymbolActionTypes,
    GraphActionTypes,
    SelectedSymbolToTable,
    RemoveSelectedSymbolToTable,
    SchematicList,
    SymbolTypes,
    SideBarVisibility,
    SchematicDocument,
    Loading,
    Background,
    Types
} from './actions';


export function setSchematicType(state,action){
    switch (action.type) {
        case Types.SET_SCHEMATIC_TYPE: {
            return action.activeSchematicType
        }
        default:
            return state
    }
}

export function setBackgrounds(state, action) {
    switch (action.type) {
        case Background.SET_BACKGROUNDS: {
            return action.backgrounds
        }
        default:
            return state
    }
}

export function setDraft(state, action) {
    return {
        ...state,
        schematicDocument: action.draft,
        schematicList: [],
        sidebarVisible: false
    }
}

export function setSchematicDocument(state, action) {
    switch (action.type) {
        case SchematicDocument.SET_SCHEMATIC_DOCUMENT: {
            return action.schematicDocument
        }
        default:
            return state
    }
}

export function setSidebarVisibility(state, action) {
    switch (action.type) {
        case SideBarVisibility.SET_SIDEBAR_VISIBILITY: {
            return action.isVisible
        }
        default:
            return state
    }
}


export function sizeReducers(state, action) {
    switch (action.type) {
        case SizeActionTypes.SET_ACTIVE_SIZE:
            return action.gridStep

        default:
            return state
    }
}

export function graphReducer(state, action) {
    switch (action.type) {
        case GraphActionTypes.SET_GRAPH:
            return Object.assign({}, state, {
                value: action.graph
            });

        default:
            return state
    }
}

export function setLoading(state, action) {
    switch (action.type) {
        case Loading.SET_LOADER: {
            return [...state, action.loader]
        }
        case Loading.REMOVE_LOADER: {
            return state.filter((loader) => loader !== action.loader)
        }
        default:
            return state
    }
}

export function activePreviewSymbolSymbolReducer(state, action) {
    switch (action.type) {
        case PreviewSymbolActionTypes.SET_ACTIVE_PREVIEW_SYMBOL:
            return action.symbol ? Object.assign({}, action.symbol) : action.symbol;

        default:
            return state
    }
}

export function selectSymbolReducers(state, action) {
    switch (action.type) {
        case SelectedSymbolToTable.SET_SELECTED_SYMBOL:
            return Object.assign([], state, action.selectedSymbol);

        case RemoveSelectedSymbolToTable.REMOVE_SELECTED_SYMBOL: {
            return Object.assign({}, state, action.removedSymbol)
        }
        default:
            return state
    }
}

export function schematicListReducer(state, action) {
    switch (action.type) {
        case SchematicList.SET_NEW_SCHEMATIC_ELEMENT: {
            return [...state, action.schematicUpdated]
        }
        case SchematicList.REFRESH_SCHEMATIC_ELEMENTS: {
            return [...action.schematicUpdated]
        }
        case SchematicList.CLEAR_SCHEMATIC_ELEMENTS: {
            return []
        }
        default:
            return state
    }
}

export function setSymbolsTypes(state, action) {
    switch (action.type) {
        case SymbolTypes.SET_SYMBOL_TYPES: {
            const allSymbolsItem = {
                id: -1,
                name: 'ALL',
                symbols: action.symbolTypes.flatMap(t => t.symbols)
            };
            return [allSymbolsItem, ...action.symbolTypes]
        }
        default:
            return state
    }
}

